import {createContext} from 'react';

export interface IReportDdReferenceRulesContextArgs {
    isLoading: boolean;
}

export const ReportDdReferenceRulesContext = createContext<IReportDdReferenceRulesContextArgs>({
    isLoading: false,
});
